// cleanName — a typed or pasted name as plain text: control characters out,
// whitespace trimmed, cut at the one-line ceiling (CL-5). A huge paste or
// markup is kept as text and looks exactly like the limit case (SF-22); the
// server checks the same ceiling.

export { cleanName, NAME_MAX };

import * as Core from "@bilda/core";

const NAME_MAX = Core.Limits.SHORT_TEXT_MAX;

const cleanName = (text: string): string =>
    text
        .replace(/\p{Cc}/gu, "")
        .trim()
        .slice(0, NAME_MAX)
        .trim();
